import { Component }                      from '@angular/core';
import { MatDialogRef }                    from '@angular/material';
import { TrainClassService }                    from './../shared/train-class.service';
import { Globals }                        from './../common/globals';

@Component({
  selector: 'sa-train-class-dialog',
  template: require('./train-class-dialog.component.html'),
  styles: [require('./train-class-dialog.component.scss')]
})
export class TrainClassDialogComponent {
  public model: any;
  public newItem: boolean;

  public errors = [];
  constructor(
    public dialogRef: MatDialogRef<TrainClassDialogComponent>,
    public trainClassService: TrainClassService,
    public globals: Globals
  ) {
  }

  save() {
    this.errors = [];
    if (this.model.className === null || !this.model.className || this.model.className.trim().length === 0 ) {
        this.errors.push('Název třídy nesmí být prázdný');
    }
    if (this.errors.length === 0) {
      this.dialogRef.close('save');
    }
  }

  delete() {
    if (confirm('Opravdu si přejete odstranit tento záznam?')) {
      this.dialogRef.close('delete');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-class-dialog/train-class-dialog.component.ts